import { Link } from 'react-router-dom';
import { Instagram, Facebook, Star } from 'lucide-react';
import kourseLogo from '@/assets/kourse-logo.png';

const COLS: Array<{ title: string; items: Array<{ label: string; to: string }> }> = [
  {
    title: 'Événements',
    items: [
      { label: 'Courses officielles', to: '/explorer' },
      { label: 'Sorties communautaires', to: '/communaute' },
      { label: 'Bourse au dossard', to: '/bourse-dossards' },
      { label: 'Calendrier complet', to: '/explorer' },
      { label: 'Éditions passées', to: '/evenements-passes' },
    ],
  },
  {
    title: 'Boutique',
    items: [
      { label: 'Voir la boutique', to: '/boutique' },
    ],
  },
  {
    title: 'Organisateurs',
    items: [
      { label: 'Publier une course', to: '/organisateur/inscription' },
      { label: 'Tarifs', to: '/a-propos' },
      { label: 'Outils pros', to: '/organisations' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    title: 'Kourse',
    items: [
      { label: 'À propos', to: '/a-propos' },
      { label: 'FAQ', to: '/faq' },
      { label: 'Contact', to: '/contact' },
      { label: 'Mentions légales', to: '/mentions-legales' },
    ],
  },
];

const Footer = () => {
  return (
    <footer id="about" className="relative border-t border-white/10 bg-[#05050a] pt-20 pb-10 overflow-hidden">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.6fr_repeat(4,1fr)] gap-10 lg:gap-10 mb-14">
          <div>
            <img src={kourseLogo} alt="Kourse" className="h-8" width={174} height={40} />
            <p className="mt-5 text-[13px] leading-relaxed text-muted-foreground max-w-[300px]">
              La plateforme de toutes les courses de France. Fabriqué avec amour par une équipe de coureurs.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href="https://www.instagram.com/kourse_officiel/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-lg border border-white/10 grid place-items-center text-muted-foreground hover:text-foreground hover:border-white/30 transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="https://www.facebook.com/kourse.officiel/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-lg border border-white/10 grid place-items-center text-muted-foreground hover:text-foreground hover:border-white/30 transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>

            {/* Avis clients */}
            <div className="mt-6 flex flex-col gap-2.5">
              <a
                href="https://g.page/r/Ca24vIcBpRWuEAE/review"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 px-3.5 py-2 rounded-lg border border-white/10 bg-white/[0.02] hover:bg-white/[0.05] hover:border-white/20 transition-all group"
              >
                <span className="text-base leading-none">★</span>
                <div className="flex flex-col">
                  <span className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground">Avis Google</span>
                  <span className="text-[12px] text-foreground font-medium group-hover:text-primary transition-colors">
                    Laisser un avis →
                  </span>
                </div>
              </a>
              <a
                href="https://fr.trustpilot.com/review/kourse.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 px-3.5 py-2 rounded-lg border border-white/10 bg-white/[0.02] hover:bg-white/[0.05] hover:border-white/20 transition-all group"
              >
                <Star className="w-4 h-4 fill-[#00b67a] text-[#00b67a]" />
                <div className="flex flex-col">
                  <span className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground">Trustpilot</span>
                  <span className="text-[12px] text-foreground font-medium group-hover:text-primary transition-colors">
                    Laisser un avis →
                  </span>
                </div>
              </a>
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title}>
              <div className="text-[10px] uppercase tracking-[0.14em] font-bold text-muted-foreground mb-4">
                {col.title}
              </div>
              <ul className="flex flex-col gap-2.5">
                {col.items.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.to}
                      className="text-[13px] text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="py-8 border-t border-b border-white/10 flex items-center justify-center overflow-hidden">
          <img
            src={kourseLogo}
            alt=""
            aria-hidden
            className="w-[94%] max-w-[1280px] h-auto opacity-[0.18]"
            style={{ filter: 'drop-shadow(0 0 60px rgba(202,255,0,0.08))' }}
          />
        </div>

        <div className="mt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-[11px] uppercase tracking-[0.06em] text-muted-foreground">
          <span>© 2026 Kourse · France</span>
          <div className="flex flex-wrap justify-center gap-5">
            <Link to="/mentions-legales" className="hover:text-foreground transition-colors">Légal</Link>
            <Link to="/mentions-legales#cgv" className="hover:text-foreground transition-colors">CGU</Link>
            <Link to="/mentions-legales#article-8" className="hover:text-foreground transition-colors">Confidentialité</Link>
            <Link to="/cookies" className="hover:text-foreground transition-colors">Cookies</Link>
          </div>
          <span>Fait par des coureurs · pour des coureurs</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
